import Modernizr from 'modernizr';
import breakpoints from "../settings/breakpoints";
import inView from "in-view";
import "../modules/share-buttons";
import fitvids from 'fitvids';

export default {
  init() {

    // Elements
    const $window = $(window);
    const $body = $('body');
    const $navMainToggle = $('#NavMainToggle');
    const $navMainSubTrigger = $('.nav-main__sub-trigger');

    // Menu toggle
    let desktop = Modernizr.mq(breakpoints.lmedium);
    $navMainToggle.on('click', function() {
      $body.toggleClass('nav-active');
      $navMainSubTrigger.removeClass('sub-active');
      $navMainSubTrigger.next('.nav-main__sub-list').hide();
    });
    $navMainSubTrigger.on('click', function() {
      if (!desktop) {
        $(this).toggleClass('sub-active');
        $(this).next('.nav-main__sub-list').slideToggle();
      }
    });
    $window.resize(function() {
      desktop = Modernizr.mq(breakpoints.lmedium);
      if (desktop) {
        $body.removeClass('nav-active');
        $navMainSubTrigger.removeClass('sub-active');
        $navMainSubTrigger.next('.nav-main__sub-list').removeAttr("style");
      }
    });

    // In View
    if (Modernizr.mutationobserver) {
      inView('.in-view')
        .on('enter', (el) => {
          el.classList.add('show');
        });
      inView.threshold(0.4);
    }

    fitvids('.cms-content');

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


      /* eslint-disable no-undef */
      // Event to show contact submission from specific page
      $('.contact-form').submit(function () {
          ga('send', {
              'hitType': 'event',
              'eventCategory': 'Contact Form',
              'eventAction': 'submitted',
              'eventLabel': window.location.pathname,
          });
      });

      $('.downloadable-document').click(function () {
          let user = $(this).data('current-user');
          let documentTitle = $(this).data('document-title');
          let label = "user: " + user + ",document-title: " + documentTitle;

          ga('send', {
              'hitType': 'event',
              'eventCategory': 'Document',
              'eventAction': 'downloaded',
              'eventLabel': label,
          });
      });

      $('.add-to-google-calendar').click(function () {
          ga('send', {
              'hitType': 'event',
              'eventCategory': 'Webinar',
              'eventAction': 'added-to-google-calendar',
              'eventLabel': $(this).data('webinar-name'),
          });
      });

      $('.add-to-ical').click(function () {
          ga('send', {
              'hitType': 'event',
              'eventCategory': 'Webinar',
              'eventAction': 'added-to-ical',
              'eventLabel': $(this).data('webinar-name'),
          });
      });

      /* eslint-enable no-undef */
  },
};

require('consent_for_cookie');

window.getConsent({
  cookies: {
    page: '/cookies',
  },
  ui: {
    main_color: "#642F6C",
    button_color: "#00AFD7",
    text: {
      accept: "Understood",
      main: "We use cookies to make your experience better. By using our services, you agree to our use of cookies.",
    },
  },
  response: {},
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js